class KlarnaExpressService {
    /*@ngInject*/
    constructor($log, $rootScope, $http, $compile, $timeout, CommonService) {
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$http = $http;
        this.$compile = $compile;
        this.$timeout = $timeout;
        this.CommonService = CommonService;
    }

    initWidget(klarnaClientToken) {
        if (klarnaClientToken !== null) {
            Klarna.Payments.init({
                client_token: klarnaClientToken
            });
        }
    }

    loadWidget() {
        Klarna.Payments.load({
            container: '#klarna-payments-container',
        }, function (res) {
        });
    }

    authorize(callback, form, redirectUrl) {
        Klarna.Payments.finalize({}, null, function (res) {
            callback(res, form, redirectUrl);
        });
    }
}

export default KlarnaExpressService;
